/*!
 * Sky Address-Autocomplete (CH)
 * Bindet PLZ → Ort + Strassen-Vorschläge automatisch an Form-Felder.
 *
 * Verwendung in HTML:
 *   <input data-sky-addr-zip ...>              ← PLZ-Feld (Pflicht)
 *   <input data-sky-addr-city ...>             ← Ort-Feld (Pflicht)
 *   <input data-sky-addr-street ...>           ← Strasse-Feld (optional)
 *   <input data-sky-addr-street-number ...>    ← Hausnummer-Feld (optional)
 *
 * Quelle: api3.geo.admin.ch (offizielle Schweizer Bundes-API, kostenlos, CORS, kein Auth)
 *
 * Verhalten:
 *   • Sobald PLZ 4 Ziffern hat → Ort wird automatisch befüllt (nur wenn Ort leer ist)
 *   • Sobald Strasse ≥3 Zeichen → Vorschläge via natives <datalist>
 *   • Bei Auswahl einer Vorschlag-Option → Strasse, Nummer, PLZ, Ort befüllen
 *   • Werte sind NIE Pflicht-Validierung — Form akzeptiert immer auch manuelle Eingabe
 */
(function(){
  'use strict';
  if (window.__skyAddrAutocompleteLoaded) return;
  window.__skyAddrAutocompleteLoaded = true;

  var API = 'https://api3.geo.admin.ch/rest/services/api/SearchServer';

  function stripHtml(s){ return String(s||'').replace(/<[^>]+>/g,'').trim(); }

  function findRelated(zipInput, attr){
    var form = zipInput.closest('form') || zipInput.closest('[data-sky-addr-scope]') || document;
    return form.querySelector('[' + attr + ']');
  }

  function lookupZip(plz, cityInput, state){
    plz = String(plz||'').trim();
    if (!/^[0-9]{4}$/.test(plz)) return;
    if (plz === state.lastZip) return;
    state.lastZip = plz;
    fetch(API + '?searchText=' + plz + '&type=locations&origins=zipcode&limit=1&lang=de', { mode:'cors' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data || !data.results || !data.results[0]) return;
        var label = stripHtml(data.results[0].attrs && data.results[0].attrs.label);
        var m = label.match(/^\d+\s*-\s*(.+)$/);
        var ort = m ? m[1].trim() : '';
        if (ort && cityInput && !cityInput.value.trim()){
          cityInput.value = ort;
          cityInput.dispatchEvent(new Event('change',{bubbles:true}));
        }
      })
      .catch(function(){});
  }

  function bindStreet(streetInput, streetNumberInput, zipInput, cityInput, state){
    // Datalist anlegen (falls noch keine vorhanden)
    var listId = streetInput.getAttribute('list');
    var datalist = listId ? document.getElementById(listId) : null;
    if (!datalist) {
      listId = 'sky-addr-suggestions-' + (state.uid++);
      datalist = document.createElement('datalist');
      datalist.id = listId;
      streetInput.setAttribute('list', listId);
      streetInput.parentNode.appendChild(datalist);
    }
    var debounce = null;
    var map = {};

    function fetchSuggestions(query){
      query = String(query||'').trim();
      if (query.length < 3) return;
      var plzCtx = zipInput && zipInput.value ? ' ' + zipInput.value : '';
      var cityCtx = cityInput && cityInput.value ? ' ' + cityInput.value : '';
      var search = encodeURIComponent(query + plzCtx + cityCtx);
      fetch(API + '?searchText=' + search + '&type=locations&origins=address&limit=8&lang=de', { mode:'cors' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if (!data || !data.results) return;
          datalist.innerHTML = '';
          map = {};
          data.results.forEach(function(res){
            var raw = res.attrs && res.attrs.label || '';
            var m = raw.match(/^(.+?)\s*<b>(\d{4})\s+(.+?)<\/b>\s*$/i);
            if (!m) return;
            var full = m[1].trim(), zip = m[2], city = m[3].trim();
            var streetName = full, num = '';
            var nm = full.match(/^(.+?)\s+(\d+\s*[a-zA-Z]?(?:\s*[-\/]\s*\d+\s*[a-zA-Z]?)?)$/);
            if (nm) { streetName = nm[1].trim(); num = nm[2].replace(/\s+/g,''); }
            var visible = full + ', ' + zip + ' ' + city;
            map[visible] = { street: streetName, number: num, zip: zip, city: city };
            var opt = document.createElement('option');
            opt.value = visible;
            datalist.appendChild(opt);
          });
        })
        .catch(function(){});
    }

    function applySelection(val){
      var s = map[val];
      if (!s) return false;
      // Wenn separates Nr-Feld vorhanden → splitten; sonst kombiniert lassen
      if (streetNumberInput) {
        streetInput.value = s.street;
        streetNumberInput.value = s.number || '';
      } else {
        streetInput.value = (s.street + (s.number ? ' ' + s.number : '')).trim();
      }
      if (zipInput) { zipInput.value = s.zip; state.lastZip = s.zip; }
      if (cityInput) cityInput.value = s.city;
      return true;
    }

    streetInput.addEventListener('input', function(){
      if (applySelection(streetInput.value)) return;
      clearTimeout(debounce);
      debounce = setTimeout(function(){ fetchSuggestions(streetInput.value); }, 280);
    });
    streetInput.addEventListener('change', function(){ applySelection(streetInput.value); });
  }

  function init(){
    var zipFields = document.querySelectorAll('[data-sky-addr-zip]');
    zipFields.forEach(function(zipInput){
      if (zipInput.__skyAddrBound) return;
      zipInput.__skyAddrBound = true;
      var cityInput = findRelated(zipInput, 'data-sky-addr-city');
      var streetInput = findRelated(zipInput, 'data-sky-addr-street');
      var streetNumberInput = findRelated(zipInput, 'data-sky-addr-street-number');
      var state = { lastZip: '', uid: Math.floor(Math.random()*1e6) };
      if (cityInput) {
        zipInput.addEventListener('input', function(){ lookupZip(zipInput.value, cityInput, state); });
        zipInput.addEventListener('blur', function(){ lookupZip(zipInput.value, cityInput, state); });
      }
      if (streetInput) {
        bindStreet(streetInput, streetNumberInput, zipInput, cityInput, state);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init bei dynamisch eingefügten Forms (z.B. Modal-Snippets)
  var mo = new MutationObserver(function(muts){
    for (var i=0; i<muts.length; i++){
      for (var j=0; j<muts[i].addedNodes.length; j++){
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-sky-addr-zip]') || n.querySelector && n.querySelector('[data-sky-addr-zip]'))) {
          init();
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
  // Public API
  window.SkyAddressAutocomplete = { init: init };
})();
